import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CInput from '@/components/CForm/CInput'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { withRouter} from 'react-router-dom'
import { tableData,tableData1} from './table2'
import {expertmuseumscoredetail} from "@/servers/goodsManageApi";
import './select.scss'
import { setStorage,getStorage} from "@/utils";
import _ from 'lodash'

import { getUserBussinesRoleList} from "@/servers/commonApi";
import {Modal} from "antd";
import {getALLMenu} from "../../servers/menuAPI";
import {
    collapsedToggle,
    setWindowInfo,
    setUserInfo,
    setCurrentTheme,
    setMenu,
    setYear,
    setUserList,
    setLibrary,
    setLbname,
    setLibraryArr
} from "../../redux/common/action";
@CBaseComponent
class Select extends Component{
    constructor(props) {
        super(props);
        this.onTableChange = this.onTableChange.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.searchDialog = this.searchDialog.bind(this);
        this.searchTable = this.searchTable.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.selectD = this.selectD.bind(this);
        this.selectCancel = this.selectCancel.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getDeleteUserListData();
        // this.getUserBussinesRoleListData();
    }


    state = {
        columns: tableData.tHead,
        dataSourceAll:[],
        dataSource: tableData.tBody,
        columns1: tableData1.tHead,
        dataSource1: tableData1.tBody,
        dataSource1all: tableData1.tBody,
        page: tableData.tPage,
        loading: true,
        museumname:'',
        modal: {
            title: '评分详情：中国国家博物馆',
            visible: false,
        },
        modal1: {
            visible1: false,
        },
        selectData:{
            museumname:'',
            levelid:-1,
            provinceid:'',
            indicatorid:'',
            minscore:'',
            maxscore:'',
            specialid:'',
            pageno:1,
            pagesize: 50
        },
        levellist:[],
        provincelist:[],
        indicatorlist:[],
        speciallist:[],
        year:[]
    };


    selectD(){
        this.state.selectData.levelid =  this.state.selectData.levelid === -1 ? '' :this.state.selectData.levelid
        this.state.selectData.provinceid =  this.state.selectData.provinceid === -1 ? '' :this.state.selectData.provinceid
        this.state.selectData.specialid =  this.state.selectData.specialid === '有加分' ? '1' :this.state.selectData.specialid === '无加分'?'0':''
        this.props.onClick2(this.state.selectData)
        this.selectCancel()
    }

    selectCancel(){
        let obj ={
                museumname:'',
                levelid:-1,
                provinceid:'',
                indicatorid:'',
                minscore:'',
                maxscore:'',
                specialid:'',
                pageno:1,
                pagesize: 50
        }
        this.setState({
            modal1: {...this.state.modal1, visible1: false},
            selectData : obj
        });
    }

    // 获取用户角色列表
    getUserBussinesRoleListData(){
        getUserBussinesRoleList().then(res=>{
            let data = res.data.list;
            let list = [];
            data.forEach(item=>{
                list.push({
                    value: item.id,
                    text: item.name
                })
            });
            let columncsClone = _.cloneDeep(this.state.columns);
            columncsClone.forEach(item=>{
                if(item.key === 'userRole'){
                    item.filters = list
                }
            });
            this.setState({
                columns: columncsClone
            });
        })
    }

    onTableChange(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    searchHandler(value){
        this.setState({
            museumname: value
        })
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

    gotoindex(data,year){
        const params = {
            annual:year,
            museumid:data.id
        }
        getALLMenu(params).then(res=>{
            const result =  this.changeitem(res.records)
            setStorage('menu', result);
            this.props.setMenu(result);
            setStorage('year', year);
            this.props.setYear(year);
            setStorage('lbname', data.name);
            this.props.setLbname(data.name);
            setStorage('showids','1.1.1')
            this.props.setLibrary(data.id);
            this.props.setLibraryArr([data]);
            setStorage('library',data.id)
            localStorage.setItem('chooseid','131110')

            this.props.history.push({
                pathname: '/informationDeclaration/museumbaseinfoScore',
            });
        })
    }

    getAlert(data){
        const params = {
            museumid:data.id
        }
        expertmuseumscoredetail(params).then(res=>{
            if (res.statecode === 0) {
                this.setState({
                    modal: {...this.state.modal, visible: true,title:'评分详情:'+data.name}
                });
                // this.props.setLibraryArr(result)
                this.props.setLibrary(data.id)
                this.props.setLbname(data.name)
                setTimeout(()=>{
                    this.setState({
                        dataSource1:res.records,
                        dataSource1all:res.records,
                    });
                },500)
            }
        })
    }

    // 重置筛选项
    resetHandler(){
        this.setState({
            searchData: {...this.state.searchData, value: '', filterTime: '', role: ''},
            page: tableData.tPage
        }, () => this.getDeleteUserListData());
        this.refs.historyRecordDeleteUserList.clearFilterData();
    }

    componentWillMount(){

    }

    computedData(data){
      return data.label1
    }
    computedData1(data){
        return data.label2
    }
    computedData2(data){
        return data.label3
    }

    computedScore(data){
        return Math.round((Number(data.score1)+Number(data.score2)+Number(data.score3))/3)
    }

    searchDialog(){
        this.setState({
            modal1: {...this.state.modal1, visible1: true}
        });
    }

    searchTable(){
        this.props.onClick(this.state.museumname)
    }

    getAlertSelect(data){
        const params = []
        this.state.dataSource1all.forEach(item=>{
            if(Number(data) === 4) {
                params.push(item)
            } else {
                if (Number(item.rank) <= Number(data)) {
                    params.push(item)
                }
            }
        })
        this.setState({
            dataSource1: params
        })
    }

    modalCancel(){
        this.setState({
            modal: {...this.state.modal, visible: false},
            dataSource1:[],
            dataSource1All:[]
        })
    }

    modalCancel1(){

    }

    changeHandler(value,name){
        if (name === 'levelid'){
            this.setState({
                selectData:{...this.state.selectData,levelid:value}
            })
        }
        if (name === 'provinceid'){
            this.setState({
                selectData:{...this.state.selectData,provinceid:value}
            })
        }
        if (name === 'museumname'){
            this.setState({
                selectData:{...this.state.selectData,museumname:value}
            })
        }
        if (name === 'indicatorid'){
            this.setState({
                selectData:{...this.state.selectData,indicatorid:value}
            })
        }
        if (name === 'minscore'){
            this.setState({
                selectData:{...this.state.selectData,minscore:value}
            })
        }
        if (name === 'maxscore'){
            this.setState({
                selectData:{...this.state.selectData,maxscore:value}
            })
        }if (name === 'specialid'){
            console.log(value,'6666');
            this.setState({
                selectData:{...this.state.selectData,specialid:value}
            })
        }


    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.arr.speciallist && nextProps.arr.speciallist.length > 0) {
            nextProps.arr.speciallist.forEach(item=>{
                item.value = item.name
            })
        }
        let d = JSON.parse(JSON.stringify(nextProps.data))
        let  data = d.splice((nextProps.pagedata.page-1)*nextProps.pagedata.pageSize,nextProps.pagedata.page*nextProps.pagedata.pageSize)
        let header = this.state.columns
        header[3].title = nextProps.year[0]+'年度'
        header[4].title = nextProps.year[1]+'年度'
        header[5].title = nextProps.year[2]+'年度'
        console.log(header,'tllll');
        let headeralert = this.state.columns1
        headeralert[3].title = nextProps.year[0]+'年度'
        headeralert[4].title = nextProps.year[1]+'年度'
        headeralert[5].title = nextProps.year[2]+'年度'
        this.setState({
            dataSourceAll:nextProps.data,
            dataSource:data,
            levellist:nextProps.arr.levellist,
            provincelist:nextProps.arr.provincelist,
            indicatorlist:nextProps.arr.indicatorlist,
            speciallist:nextProps.arr.speciallist,
            loading:false,
            page:nextProps.pagedata,
            year: nextProps.year
        })
    }

    componentDidMount(){
    }
    render(){
        return (
            <div className='history-record-delete-user-list'>
                <div className='flex filter-wrap'>
                    <div className='flex filter-left'>
                        <h3>博物馆列表</h3>
                    </div>
                    <div className='flex filter-right'>
                      <CInput value={this.state.museumname}
                                     className='search-input'
                                     placeholder='请输入博物馆名称'
                                     onChange={this.searchHandler} />
                        <CButton type='primary' onClick={this.searchTable}>搜索</CButton>
                        <CButton type='primary' onClick={this.searchDialog}>高级搜索</CButton>
                    </div>
                </div>
                <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource} page={this.state.page} onTableChange={this.onTableChange}>
                    <div
                        slot='operate2019'
                        render={(text, record, index) => (
                            <div >
                                <span onClick={() => this.gotoindex(record,this.state.year[0])} style={{cursor:"pointer",fontWeight:'bold'}}>{this.computedData(record)}</span>
                            </div>
                        )} />
                    <div
                        slot='operate2020'
                        render={(text, record, index) => (
                            <div>
                                <span onClick={() => this.gotoindex(record,this.state.year[1])} style={{cursor:"pointer",fontWeight:'bold'}}>{this.computedData1(record)}</span>
                            </div>
                        )} />
                    <div
                        slot='operate2021'
                        render={(text, record, index) => (
                            <div >
                                <span onClick={() => this.gotoindex(record,this.state.year[2])} style={{cursor:"pointer",fontWeight:'bold'}}>{this.computedData2(record)}</span>
                            </div>
                        )} />
                    <div
                        slot='operatehz'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' size="mini" onClick={() => this.getAlert(record)}>
                                    查看
                                </CButton>
                            </div>
                        )} />
                </CTable>
                <Modal
                    title={this.state.modal.title}
                    visible={this.state.modal.visible}
                    onCancel={this.modalCancel}
                    footer={null}
                    width={860}
                >
                    <div>
                        <div>
                            指标项显示层级：
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(4)} style={{marginRight:'20px'}}>
                                全部
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(3)} style={{marginRight:'20px'}}>
                                三级及以上
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.getAlertSelect(2)} style={{marginRight:'20px'}}>
                                二级及以上
                            </CButton>
                        </div>
                        <CTable ref='historyRecordDeleteUserList1' checked={false} loading={false} columns={this.state.columns1} dataSource={this.state.dataSource1}>
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                            <div
                                slot='operate2019'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2020'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData1(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='operate2021'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        <span>{this.computedData2(record)}</span>
                                    </div>
                                )} />
                            <div
                                slot='index'
                                render={(text, record, index) => (
                                    <div className='operate'>
                                        {index+1}
                                    </div>
                                )} />
                        </CTable>
                    </div>
                </Modal>
                <Modal
                    title='高级搜索'
                    visible={this.state.modal1.visible1}
                    onCancel={this.modalCancel1}
                    closable={false}
                    width={650}
                    footer={null}
                >
                    <div className='search-form'>
                        <div className='search-form-item'>
                            <div className='item-left'>博物馆质量等级：</div>
                            <div className='item-right'>
                                {this.state.levellist.map(item=>{
                                    return (
                                        <CButton type='primary' className={item.id === this.state.selectData.levelid ? 'choosein' :''} size="mini" onClick={() => this.changeHandler(item.id,'levelid')} style={{marginRight:'20px'}}>
                                            {item.name}
                                        </CButton>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='search-form-item'>
                            <div className='item-left'>博物馆所处省份:</div>
                            <div className='item-right'>
                                <CSelect
                                    placeholder='请选择博物馆所处省份'
                                    value={this.state.selectData.provinceid}
                                    options={this.state.provincelist}
                                    onChange={(e)=>{this.changeHandler(e,'provinceid')}}
                                />
                            </div>
                        </div>
                        <div className='search-form-item'>
                            <div className='item-left'>博物馆名称:</div>
                            <div className='item-right'>
                                <CInput
                                    placeholder='请输入博物馆名称'
                                    value={this.state.selectData.museumname}
                                    onChange={(e)=>{this.changeHandler(e,'museumname')}}
                                />
                            </div>
                        </div>
                        <div className='search-form-item'>
                            <div className='item-left'>指标项分值:</div>
                            <div className='item-right'>
                                <CSelect
                                    style={{width:'100px'}}
                                    placeholder='请选择指标项分值'
                                    value={this.state.selectData.indicatorid}
                                    options={this.state.indicatorlist}
                                    onChange={(e)=>{this.changeHandler(e,'indicatorid')}}
                                />
                                <div className="scores">
                                <CInput
                                    style={{width:'100px'}}
                                    value={this.state.selectData.minscore}
                                    onChange={(e)=>{this.changeHandler(e,'minscore')}}
                                />
                                <span>分至</span>
                                <CInput
                                    style={{width:'100px'}}
                                    value={this.state.selectData.maxscore}
                                    onChange={(e)=>{this.changeHandler(e,'maxscore')}}
                                />
                                </div>
                            </div>
                        </div>
                        <div className='search-form-item'>
                            <div className='item-left'>特色加分项:</div>
                            <div className='item-right'>
                                <CRadio
                                    value={this.state.selectData.specialid}
                                    options={this.state.speciallist}
                                    onChange={(e)=>{this.changeHandler(e,'specialid')}}
                                />
                            </div>
                        </div>
                        <div style={{textAlign:'center'}}>
                            <CButton type='primary' size="mini" onClick={() => this.selectD()} style={{marginRight:'10px'}}>
                                查询
                            </CButton>
                            <CButton type='primary' size="mini" onClick={() => this.selectCancel()}>
                                取消
                            </CButton>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        breadcrumbData: state.breadcrumbData,
        collapsed: state.collapsed,  // 侧边栏是否展开
        windowInfo: state.windowInfo,
        userInfo: state.userInfo,
        userList:  state.userList,
        libraryid: state.libraryid,
        setLbname:state.setLbname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
        setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
        setUserInfo: bindActionCreators(setUserInfo, dispatch),
        setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
        setUserList: bindActionCreators(setUserList, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        setYear:bindActionCreators(setYear,dispatch),
        setLibrary:bindActionCreators(setLibrary,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
        setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Select);
